import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import {
    EParticipantOnboardingStep as EStep,
    EParticipantOnboardingQueryUrl as EUrl
} from "./participant.onboarding.api.config"
import type {
    IParticipantOnboardingCoachStepCoachesQueryDto as ICoachStepCoachesQueryDto,
    IParticipantOnboardingCoachStepPairingQueryDto as ICoachStepPairingQueryDto,
    IParticipantOnboardingCoachStepSessionQueryDto as ICoachStepSessionQueryDto,
    IParticipantOnboardingDiagnosticStepQueryDto as IDiagnosticStepQueryDto,
    IParticipantOnboardingHoldsStepQueryDto as IHoldsStepQueryDto,
    IParticipantOnboardingReflectionStepQueryDto as IReflectionStepQueryDto,
    IParticipantOnboardingStepsInfoQueryDto as IStepInfoQueryDto,
    IParticipantOnboardingVideoStepQueryDto as IVideoStepQueryDto
} from "./participant.onboarding.api.types"

export default {
    stepInfo: async (): Promise<IStepInfoQueryDto> => {
        const { data }: AxiosResponse<IStepInfoQueryDto> = await axiosClient.get(EUrl.StepInfo())

        return data
    },
    steps: {
        [EStep.Video]: async (): Promise<IVideoStepQueryDto> => {
            const { data }: AxiosResponse<IVideoStepQueryDto> = await axiosClient.get(EUrl.Steps.Video())

            return data
        },
        [EStep.Diagnostic]: async (): Promise<IDiagnosticStepQueryDto[]> => {
            const { data }: AxiosResponse<IDiagnosticStepQueryDto[]> = await axiosClient.get(EUrl.Steps.Diagnostic())

            return data
        },
        [EStep.Reflection]: async (): Promise<IReflectionStepQueryDto[]> => {
            const { data }: AxiosResponse<IReflectionStepQueryDto[]> = await axiosClient.get(EUrl.Steps.Reflection())

            return data
        },
        [EStep.Holds]: async (): Promise<IHoldsStepQueryDto> => {
            const { data }: AxiosResponse<IHoldsStepQueryDto> = await axiosClient.get(EUrl.Steps.Holds())

            return data
        },
        [EStep.Coach]: {
            session: async (): Promise<ICoachStepSessionQueryDto> => {
                const { data }: AxiosResponse<ICoachStepSessionQueryDto> = await axiosClient.get(
                    EUrl.Steps.Coach.Session()
                )

                return data
            },
            pairing: async (): Promise<ICoachStepPairingQueryDto> => {
                const { data }: AxiosResponse<ICoachStepPairingQueryDto> = await axiosClient.get(
                    EUrl.Steps.Coach.Pairing()
                )

                return data
            },
            coaches: async (): Promise<ICoachStepCoachesQueryDto> => {
                const { data }: AxiosResponse<ICoachStepCoachesQueryDto> = await axiosClient.get(
                    EUrl.Steps.Coach.Coaches()
                )

                return data
            }
        }
    }
}
